'use strict';

module.exports = {
    initQuantitySelector: function () {
        var quantityModuleClass = '.quantity-module';
        var quantitySelectClass = '.quantity-select';
        var quantityInputClass = '.quantity-input';
        var quantityPlusClass = '.quantity-increase';
        var quantityMinusClass = '.quantity-decrease';

        var getQtyArray = function ($select) {
            var qtys = [];
            $select.find('option').each(function () {
                qtys.push($(this).val());
            });
            return qtys;
        };

        var qtySelectorInputHandler = function (e) {
            var $qty = $(this).parents(quantityModuleClass);
            var $select = $qty.find(quantitySelectClass);
            var $input = $qty.find(quantityInputClass);
            var $plus = $qty.find(quantityPlusClass);
            var $minus = $qty.find(quantityMinusClass);
            var quantities = getQtyArray($select);
            var currentIndex = quantities.indexOf($select.val());
            var newVal = null;
            var newIndex;

            // if the input field triggered the event but its value didn't change, EXIT
            if ($(this).is($input) && $input.data('previous-value').toString() === $input.val()) {
                return;
            }

            if ($(this).is($minus)) {
                // minus was clicked
                newIndex = currentIndex - 1;
                newVal = quantities[newIndex];
            } else if ($(this).is($plus)) {
                // plus was clicked
                newIndex = currentIndex + 1;
                newVal = quantities[newIndex];
            } else {
                // was updated via the input text field
                newVal = $(this).val();
                newIndex = quantities.indexOf(newVal);
            }
            if (typeof newVal === 'undefined') {
                return;
            }

            // attempt to change the <select> value
            $select.trigger({
                type: 'change',
                newVal: newVal
            });

            // if it did not work, reset input field to previous value and EXIT
            if ($select.val().toString() !== newVal.toString()) {
                e.preventDefault();
                $input.val($input.data('previous-value'));
                return;
            }

            // if it did work, update input field and disable plus/minus buttons if nec
            if (newIndex === 0) {
                $minus.addClass('disabled').attr('disabled', 'disabled');
            } else {
                $minus.removeClass('disabled').removeAttr('disabled');
            }
            if (newIndex === quantities.length - 1) {
                $plus.addClass('disabled').attr('disabled', 'disabled');
            } else {
                $plus.removeClass('disabled').removeAttr('disabled');
            }

            // update the displayed value
            $input.val(newVal);

            // reset previous-value tracker
            $input.data('previous-value', $input.val());
        };

        var selectChangeHandler = function (e) {
            var newVal = e.newVal || $(this).val();
            var quantities = getQtyArray($(this));

            // check if the value exists as an option, and if not, EXIT
            if (quantities.indexOf(newVal) < 0) {
                e.preventDefault();
                return false;
            }
            // set the <select> value
            $(this).val(newVal);

            // update the <input> value
            $(this).parents(quantityModuleClass).find(quantityInputClass).val(newVal);

            return $(this);
        };

        // init jQuery event handlers

        $(quantityModuleClass).on('change click', quantityPlusClass + ':not(.disabled), ' + quantityMinusClass + ':not(.disabled), ' + quantityInputClass, qtySelectorInputHandler);
        $(quantityModuleClass).on('change', quantitySelectClass, selectChangeHandler);
    }
};
